const font = {
  heading: "Raleway",
  body: "Raleway",
};

export default font;
